import React, { FC, SyntheticEvent } from 'react';
import {
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup
} from '@mui/material';
import { IRadioButton } from 'core/interface/radioButton';

import './index.scss';

const RadioButton: FC<IRadioButton> = ({
  buttons,
  onChange,
  className,
  isRow = true
}): JSX.Element => {
  const handleRadioChange = (e: SyntheticEvent) => {
    onChange((e.target as HTMLInputElement).value);
  };

  return (
    <FormControl className={className}>
      <RadioGroup
        className={className}
        row={isRow}
        aria-labelledby="demo-row-radio-buttons-group-label"
        name="row-radio-buttons-group"
      >
        {buttons.map((item, index) => (
          <div key={index} className="radio">
            <FormControlLabel
              onClick={handleRadioChange}
              value={item.value}
              control={<Radio checked={item.isChecked} />}
              label={item.label}
              style={{ color: '#2a2a2a' }}
            />
            <span className="right_text">{item.right_text}</span>
          </div>
        ))}
      </RadioGroup>
    </FormControl>
  );
};

export default RadioButton;
